import { PageProps } from "@/types";
import { Head, Link } from "@inertiajs/react";
import Guest from "@/Layouts/GuestLayout";
import DefaultView from "../partials/DefaultView";

const GuestView = ({
    title,
    details,
    use_pdf,
    file_full_url
} : PageProps<{
    title: string;
    details?: string;
    use_pdf?: boolean;
    file_full_url?: string;
}>) => {
    return (
        <DefaultView title={title} details={details} is_pdf={use_pdf} pdf_url={file_full_url} guestView={true}/>
    )
}


GuestView.layout = (page: any) => (
    <Guest
      children={page}
    />
);
  
export default GuestView;